import React from "react";
import ItemDetailView from "presentational/common/ItemDetailView/ItemDetailView";
import { getImgUrl } from "lib/imageUrlHelper";
import { getDeviceType } from "lib/deviceInfo";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const mobileCss = config.css.mobile;

const css = {
  root: {
    marginTop:
      getDeviceType() === "mobile"
        ? -mobileCss.paddingBetweenHeaderbarAndFirstContent +
          mobileCss.paddingBetweenHeaderbarAndFirstContentForItemDetail
        : undefined
  }
};

RootItemProfileView.propTypes = {
  itemInfo: PropTypes.object
};
RootItemProfileView.defaultProps = {
  itemInfo: null
};

function RootItemProfileView(props) {
  const { itemInfo } = props;

  return (
    <div style={css.root}>
      {itemInfo && (
        <ItemDetailView
          mode={"normal"}
          imageSrc={getImgUrl("item", itemInfo.image)}
          category={itemInfo.category}
          brand={itemInfo.brand}
          color={itemInfo.color}
          tag={itemInfo.tag}
          gender={itemInfo.gender}
        />
      )}
    </div>
  );
}

export default RootItemProfileView;
